<template>
  <div>
    <!--Breadcrumb button-->
    <breadcrumb-button>
      <template #beforeDropdown>
        <b-button
            variant="success"
            class="btn-icon position-relative"
            v-b-tooltip
            v-bind:title="$t('operations.add')"
            @click="onCampaignSelected(null)"
        >
          <i class="fa-solid fa-bullhorn"></i>
          <i
              class="fa-solid fa-plus position-absolute"
              style="font-size: 0.6em; top: 14px; right: 1px;"
          ></i>
        </b-button>
      </template>
      <template #items>
        <b-dropdown-item @click="openColumnsModal">
          <feather-icon
              icon="CheckSquareIcon"
              size="16"
          />
          <span class="align-middle ml-50">{{ $t('columns.self') }}</span>
        </b-dropdown-item>
      </template>
    </breadcrumb-button>

    <!--Filters-->
    <filter-card v-model="filter" v-bind:fields="filterFields" search/>

    <!-- Tabs with tables -->
    <b-card no-body>
      <b-card-header class="pb-50">
        <h5>{{ $t("menu.campaigns") }}</h5>
      </b-card-header>
      <b-card-body>
            <campaigns-table
                ref="campaignTable1"
                v-bind:filters="filter"
                v-bind:columns="columns"
                :has-selection="false"
                @selected="onCampaignSelected"
                :lazy="true"
            />

      </b-card-body>
    </b-card>

    <!--Modal-->
    <columns-modal ref="columns-modal" column-key="campaigns" v-model="columns"
                   v-bind:columns-names="columnsNames" />
    <campaign-modal ref="campaign-modal" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BreadcrumbButton from '@/components/widget/breadcrumbButton'
import CampaignSearchRequest from '@/model/campaign/CampaignSearchRequest'
import ColumnsModal from '@/components/modal/columnsModal'
import Campaign from '@/model/campaign/Campaign'
import mixinPermissions from '@/components/mixin/mixinPermissions'
import mixinBase from '@/components/mixin/mixinBase'
import CampaignModal from '@/components/modal/campaignModal'
import FilterCard from '@/components/widget/FilterCard'
import CampaignFilterFields from '@/model/filter/CampaignFilterFields'
import CampaignsTable from '@/components/tables/CampaignsTable'

export default {
  name: 'CampaignsView',
  components: {
    CampaignsTable,
    FilterCard,
    CampaignModal,
    ColumnsModal,
    BreadcrumbButton
  },
  mixins: [mixinBase, mixinPermissions],
  data() {
    return {
      columnsNames: Object.keys(Campaign()),
      filter: CampaignSearchRequest(),
      filterLoaded: false,
      columns: [],
      filterFields: null,
    }
  },
  async created() {
    await this.refreshData()
    this.filterFields = CampaignFilterFields()
  },
  computed: {
    ...mapGetters('data', ['allOrganizations']),
  },
  methods: {
    ...mapActions('campaign', ['refreshData']),
    openColumnsModal() {
      this.$refs['columns-modal'].showModal()
    },
    onCampaignSelected(selectedId) {
      this.$refs['campaign-modal'].showModal(selectedId)
    },
  }
}
</script>
